import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-778ccedc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-caption q-ml-sm" }
const _hoisted_2 = { class: "detail-body" }
const _hoisted_3 = { class: "detail-body__posts" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h6 q-mb-md" }, "Tagged Posts ", -1))
const _hoisted_5 = {
  key: 1,
  class: "row q-col-gutter-md"
}
const _hoisted_6 = {
  key: 2,
  class: "text-center q-mt-md"
}
const _hoisted_7 = {
  key: 3,
  class: "text-center text-grey-6 q-pa-xl"
}
const _hoisted_8 = { class: "detail-body__faces" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_PostTagCard = _resolveComponent("PostTagCard")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_PersonFacesGrid = _resolveComponent("PersonFacesGrid")!
  const _component_EditPersonModal = _resolveComponent("EditPersonModal")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_ctx.person)
    ? (_openBlock(), _createBlock(_component_q_card, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, { class: "bg-primary text-white" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                icon: "fa fa-close",
                flat: "",
                round: "",
                dense: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
              }),
              _createVNode(_component_q_toolbar_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.person.label || 'Unnamed Person'), 1)
                ]),
                _: 1
              }),
              (_ctx.isGranted('MANAGE_PERSONS'))
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    icon: "fa fa-edit",
                    flat: "",
                    round: "",
                    dense: "",
                    onClick: _ctx.editPerson
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Edit label")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.total) + " face" + _toDisplayString(_ctx.total !== 1 ? 's' : ''), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _hoisted_4,
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                        key: 0,
                        indeterminate: "",
                        color: "primary",
                        class: "q-mb-md"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.tags.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: tag.id,
                            class: "col-xs-12 col-sm-6 col-md-4"
                          }, [
                            _createVNode(_component_PostTagCard, { tag: tag }, null, 8, ["tag"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.hasMore)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_q_btn, {
                          color: "primary",
                          label: "Load More",
                          loading: _ctx.loadingMore,
                          flat: "",
                          dense: "",
                          onClick: _ctx.loadMore
                        }, null, 8, ["loading", "onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.loading && _ctx.tags.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, " No tagged posts found for this person "))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_PersonFacesGrid, {
                ref: "facesGrid",
                "client-id": _ctx.clientId,
                "person-id": _ctx.person.id
              }, null, 8, ["client-id", "person-id"])
            ])
          ]),
          _createVNode(_component_EditPersonModal, {
            ref: "editPersonModal",
            onUpdated: _ctx.onPersonUpdated
          }, null, 8, ["onUpdated"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}